import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "SmartPillUI"*/ './lazyIndex'));

// Components
export const SmartPill = createLazyComponent(lazyModule, m => m.SmartPill);
export const SmartPillBlock = createLazyComponent(lazyModule, m => m.SmartPillBlock);

// Component interfaces
export { SmartPillBlockProps } from './components/SmartPillBlock';
export { SmartPillProps } from './components/SmartPill';
